import { useEffect, useState } from "react";

import {
  onUpdateReady,
  platform,
  isMobileApp,
  installUpdateAndRelaunch,
  skipUpdateVersion,
} from "~/lib/platform";

export interface UpdateOffer {
  version: string;
  restart: () => Promise<void>;
  skip: () => Promise<void>;
}

export function useUpdater(): UpdateOffer | null {
  const [version, setVersion] = useState<string | null>(null);

  useEffect(() => {
    if (platform !== "tauri" || isMobileApp) return;

    let unlisten: (() => void) | null = null;
    let cancelled = false;

    void onUpdateReady((incoming) => {
      if (cancelled) return;
      setVersion(incoming);
    })
      .then((fn) => {
        if (cancelled) {
          fn();
          return;
        }
        unlisten = fn;
      })
      .catch((err) => console.error("Update listener failed", err));

    return () => {
      cancelled = true;
      if (unlisten) unlisten();
    };
  }, []);

  if (version === null) return null;

  return {
    version,
    restart: () => installUpdateAndRelaunch(version),
    skip: async () => {
      await skipUpdateVersion(version);
      setVersion(null);
    },
  };
}
